/**
 * @generated SignedSource<<14a8a6d83796b62ad3f25f77f436e65c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type IntegrationNewsfeedProvider = "BOKAKLIPP" | "FALCON";
import { FragmentRefs } from "relay-runtime";
export type WidgetNewsfeed_widgetNewsfeed$data = {
  readonly newsfeed: {
    readonly provider: IntegrationNewsfeedProvider;
  };
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"NewsfeedNative_widgetNewsfeed" | "NewsfeedWeb_widgetNewsfeed">;
  readonly " $fragmentType": "WidgetNewsfeed_widgetNewsfeed";
};
export type WidgetNewsfeed_widgetNewsfeed$key = {
  readonly " $data"?: WidgetNewsfeed_widgetNewsfeed$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNewsfeed_widgetNewsfeed">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNewsfeed_widgetNewsfeed",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationNewsfeed",
      "kind": "LinkedField",
      "name": "newsfeed",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "provider",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NewsfeedNative_widgetNewsfeed"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NewsfeedWeb_widgetNewsfeed"
    }
  ],
  "type": "WidgetNewsfeed",
  "abstractKey": null
};

(node as any).hash = "82aa9c2c140f898d1855e8e78669c112";

export default node;
